import { GridFitNote } from '../../views/grid/GridFitNote';
import { AdvancedChips } from '../advanced/AdvancedChips';
import { AdvancedPanel } from '../advanced/AdvancedPanel';
import { useAdvancedPanel } from '../advanced/useAdvancedPanel';
import { FilterRow } from '../filters/FilterRow';
import { ListToolbar } from '../toolbar/ListToolbar';
import type { IViewPageHeadProps } from './IViewPageHeadProps';
import { PageHeader } from './PageHeader';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/** Сторінки модуля, над якими прототип показує «Приховано стовпців: N» таблиці (hasColsHidden: панель і подання завдань; інші подання — ні). */
const NOTED_PAGES: readonly string[] = ['analytics', 'byarea', 'byteam', 'traces', 'tmatrix'];

/**
 * Шапка сторінки окремого подання модуля (прототип v4, «Аналітика», «Зал засідань»): рядок над заголовком «Модуль — Таблиця», заголовок
 * подання й опис; праворуч «Фільтр [Усі записи · N ▾]» і «Розширені фільтри» (без вкладок і збережених подань); панель умов; панель дій
 * лише з тегами й пошуком; на «Аналітиці» й поданнях завдань — примітка «Приховано стовпців: N…» таблиці модуля (GridFitNote).
 */
export function ViewPageHead({ model, eyebrow, title, description }: IViewPageHeadProps) {
  const { page } = useWorkspaceParams();
  const adv = useAdvancedPanel(model);
  return (
    <>
      <PageHeader eyebrow={eyebrow} title={title} description={description} />
      <FilterRow model={model} wholeType table={false} advanced={{ count: adv.applied, open: adv.open, onToggle: adv.toggle }}
        chips={<AdvancedChips ws={model.ws} rt={model.rt} conditions={adv.conditions} onChange={adv.change} quick={adv.quick} onQuick={adv.changeQuick} />} />
      {adv.open && (
        <AdvancedPanel model={model} conditions={adv.conditions} onChange={adv.change} quick={adv.quick} onQuick={adv.changeQuick} onClose={adv.close} />
      )}
      <ListToolbar model={model} />
      {page && NOTED_PAGES.includes(page) && <GridFitNote model={model} />}
    </>
  );
}
